import { Injectable } from '@angular/core';
import { Papa, PapaParseParser } from 'ngx-papaparse';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CsvParserService {

  constructor(
    private papa: Papa,
  ) {
  }

  parseCsvString(csvString: string, delimiter?: string) {
    return this.papa.parse(csvString, { delimiter: delimiter ? delimiter : '' });
  }

  parseCsvFile(file: File, delimiter?: string): Observable<{ data: any, parser: PapaParseParser }> {
    return new Observable((observer) => {
      this.papa.parse(file, {
        delimiter: delimiter ? delimiter : '',
        chunk: (result, parser) => {
          parser.pause();
          observer.next({ data: result.data, parser: parser });
        },
        complete: (results) => {
          observer.complete();
        },
        error: (error) => observer.error(error),
      });
    });
  }
}
